const SELECT_CONTENT_DEFAULT_SIDE_OFFSET = 4;
const SELECT_CONTENT_DEFAULT_COLLISION_PADDING = 16;

export { SELECT_CONTENT_DEFAULT_COLLISION_PADDING, SELECT_CONTENT_DEFAULT_SIDE_OFFSET };
//# sourceMappingURL=style.mjs.map
